import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

//Import Components
import LeftSidebarMenu from "./LeftSidebarMenu";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.capitalizeFirstLetter.bind(this);
  }

  //function for capital first letter of current page pathname
  capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  componentDidMount() {
    this.updatePageTitle();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.updatePageTitle();
    }
  }

  updatePageTitle = () => {
    const { t } = this.props;
    const pathname = this.props.location.pathname;
    const baseRoute = pathname.split('/')[1] || '';
    let currentpage =
      pathname === "/" || baseRoute === ""
        ? t("Dashboard")
        : this.capitalizeFirstLetter("/" + baseRoute);

    //set document title according to page path name
    document.title = currentpage + " " + process.env.REACT_APP_TAGLINE;
  }

  render() {
    return (
      <React.Fragment>
        <div className="layout-wrapper d-lg-flex">
          {/* left sidebar menu */}
          <LeftSidebarMenu
            routeTab={this.props.location.pathname.replace("/", "")}
          />
          {/* render page content */}
          {this.props.children}
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(withRouter(Index));
